export enum ViewMode {
  WF = 'WF',
  DETAIL = 'DETAIL',
  WITHDRAW = 'WITHDRAW',
  TRANSFER = 'TRANSFER'
}
